export enum FBFieldTypeId {
    ContactName = 1,
    CustomerId,
    CustomerEmail,
    PhoneNumber,
    InitialMessage,
    SkillDropdown,
    Dropdown,
    Custom
}
